// FAQCategoriesDropdownMenu.tsx
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import FAQCategoriesDropdownList from './FAQCategoriesDropdownList';
import styles from './FAQCategoriesDropdownMenu.module.scss';
import dropdownArrow from '../../../assets/images/faq_dropdownArrow.svg';

type FAQCategoriesDropdownMenuProps = {
  menuName: string;
  questions: { [key: string]: vp.FAQQuestionsList };
  categoryName: string;
  dataLoaded: boolean;
};

const FAQCategoriesDropdownMenu: React.FC<FAQCategoriesDropdownMenuProps> = ({
  menuName,
  questions,
  categoryName,
  dataLoaded,
}) => {
  const location = useLocation();
  const { category, subCategory } =
    (location?.state as { category: string; subCategory: string; selectedQuestion: string }) || {};

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [hasBeenOpened, setHasBeenOpened] = useState(false);

  useEffect(() => {
    setIsDropdownOpen(false);
  }, [categoryName]);

  useEffect(() => {
    if (subCategory === menuName) {
      setIsDropdownOpen(true);
    }
  }, [category, menuName]);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
    setHasBeenOpened(true);
  };

  return (
    <div className={styles.dropDownMenu} onClick={toggleDropdown}>
      <div className={styles.dropDownMenuTitleContainer}>
        <div className={styles.dropDownMenu__title}>{menuName}</div>
        <img
          src={dropdownArrow}
          alt=""
          style={isDropdownOpen ? { transform: 'rotate(180deg)' } : { transform: 'unset' }}
        />
      </div>
      {isDropdownOpen && Object.keys(questions).length !== 0 ? (
        <div className={styles.dropDownList}>
          {Object.values(questions).map((data) => (
            <FAQCategoriesDropdownList
              ID={data.ID}
              title={data.Question}
              description={data.Answer}
              dataLoaded={dataLoaded}
              hasBeenOpened={hasBeenOpened}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default FAQCategoriesDropdownMenu;
